import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { EQUAL_WEIGHTS_TITLE } from '@upright/common/model/input/value-sets';
import { getNetImpactLensSelectionOptions } from '@upright/ui/common/generic/utilities/storage';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { LensOptions } from '@upright/ui/common/upright/core/impact-lens-profile/types';
import { AggregateResultArea } from '@upright/ui/common/upright/core/impact-lenses/net-impact/aggregate-result';
import { aggregateNetImpactResultAreaHeight } from '@upright/ui/common/upright/core/impact-lenses/net-impact/aggregate-result/layout';
import { DimensionBarAndLabel } from '@upright/ui/common/upright/core/impact-lenses/net-impact/data-area';
import { defaultNetImpactLensOptions } from '@upright/ui/common/upright/core/impact-lenses/net-impact/default-options';
import { NetImpactLensEmptyState } from '@upright/ui/common/upright/core/impact-lenses/net-impact/empty-state';
import {
  NetImpactInfoBoxConnectors,
  NetImpactInfoBoxes,
} from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes';
import {
  NetImpactLensSelectionState,
  netImpactLensSelectionStateHandlers,
} from '@upright/ui/common/upright/core/impact-lenses/net-impact/selection-state';
import { netImpactLensTexts } from '@upright/ui/common/upright/core/impact-lenses/net-impact/texts';
import {
  NetImpactLensData,
  NetImpactLensOptions,
} from '@upright/ui/common/upright/core/impact-lenses/net-impact/types';
import { NetImpactLensViewOptionsSelector } from '@upright/ui/common/upright/core/impact-lenses/net-impact/view-options-selector';
import { ImpactLens, ImpactLensProfileLayer } from '@upright/ui/common/upright/core/impact-lenses/types';
import { ImpactBar } from '../../impact-lens-profile/common/components/data-area/impact-bars';
import { TotalSumsArea } from './total-sums';
import { AdditionalInfoArea } from './additional-info';

export const netImpactLens: ImpactLens<ImpactLensType.UPRIGHT_NET_IMPACT, NetImpactLensData, NetImpactLensOptions> = {
  type: ImpactLensType.UPRIGHT_NET_IMPACT,
  ImpactDataComponent: {
    component: ImpactBar,
    layer: ImpactLensProfileLayer.SVG,
  },
  DimensionDataComponent: {
    component: DimensionBarAndLabel,
    layer: ImpactLensProfileLayer.SVG,
  },
  infoBoxes: {
    DivComponent: NetImpactInfoBoxes,
    SvgComponent: NetImpactInfoBoxConnectors,
  },
  TopRightActions: NetImpactLensViewOptionsSelector,
  AggregateResultArea: AggregateResultArea,
  defaultOptions: defaultNetImpactLensOptions,
  EmptyState: NetImpactLensEmptyState,
  TotalSumsArea: TotalSumsArea,
  AdditionalInfoArea: AdditionalInfoArea,
  boxMode: (fullWidth, options) => {
    if ((options as NetImpactLensOptions).disableResponsiveBoxMode) return LensBoxMode.SIDE;

    if (fullWidth < 950) {
      return LensBoxMode.MODAL;
    }
    return LensBoxMode.SIDE;
  },
  boxesAreaWidth: (_fullWidth: number) => {
    return 230;
  },
  aggregateResultAreaHeight: (width: number, options: LensOptions<ImpactLensType.UPRIGHT_NET_IMPACT>) => {
    const valueSet = (options as NetImpactLensOptions).valueSet;
    const isDefaultValueSet = valueSet === EQUAL_WEIGHTS_TITLE;
    const numberOfScores = isDefaultValueSet ? 1 : 2;
    return aggregateNetImpactResultAreaHeight(width, numberOfScores);
  },
  defaultSelectionState: getNetImpactLensSelectionOptions(),
  ...netImpactLensSelectionStateHandlers,
  ...netImpactLensTexts,
  showTotalSumsArea: (selectionState: NetImpactLensSelectionState) => {
    return selectionState.showTotalSums;
  },
};
